$(function(){
    $(document).on('click','.u_size_chart_btn',function(){
        $('.u_size_chart_block').show()
        $('body').addClass('u_over_spopup')
    })
     $(document).on('click','.u_size_chart_close,.u_size_chart_overlay',function(){
        $('.u_size_chart_block').hide()
        $('body').removeClass('u_over_spopup')
    })
})